module.exports = __webpack_public_path__ + "static/media/truck.b8677f89.svg";